import "../scss/page.scss";
import "../scss/register.scss";
import initPasswordToggles from "./scripts/common/password-toggle.js";
import "./scripts/register/base.js";

initPasswordToggles();
